<template>
    <b-container id="inventory-products-details" v-if="$can('view-product-details') || $can('view-all')" fluid>
        <b-row class="page-title">
            <b-container fluid>
                <h3>Product Detail: {{ item.sku }}</h3>
                <hr>
            </b-container>
        </b-row>
        <b-row>
            <b-container fluid>
                <b-row class="button-row" v-if="item && item.item_image">
                    <b-col cols="7">
                        <b-button variant="outline-primary"
                            @click="openModal('modal-inventory-products-edit-product', item.id)"><i
                                class="fas fa-edit"></i> Edit Item</b-button>
                        <b-button variant="outline-primary"><i class="fas fa-exchange-alt"></i> Transfer Stock
                        </b-button>
                        <b-button variant="outline-primary" @click="recalcCounts"><i class="fas fa-redo-alt"></i> Recalc
                        </b-button>
                        <!-- <b-button variant="outline-primary" @click="openModal('modal-inventory-products-adjust-quantity', item.id)"><i class="fas fa-cubes"></i> Manual Stock Adjustment</b-button> -->
                        <b-button v-if="$can('view-all')" variant="outline-primary"
                            @click="openModal('modal-inventory-products-edit-sources', item.id)"><i
                                class="fas fa-link"></i> Edit Source</b-button>
                        <b-button v-if="$can('execute-export') || $can('view-all')" variant="outline-primary"
                            :disabled="exportingSales" @click="exportSales">
                            <span v-if="exportingSales">
                                <b-spinner small></b-spinner>
                                <strong> Exporting...</strong>
                            </span>
                            <span v-else><i class="fas fa-file-excel"></i> Export Sales</span>
                        </b-button>
                        <b-button v-if="item.product_type == 'Bundle' && ($can('view-all') || $can('view-product-details-build-kit'))" variant="outline-primary"
                            @click="openModal('modal-inventory-products-build-kit', item.id)"><i
                                class="fas fa-box-open"></i> Build Kit</b-button>
                    </b-col>
                </b-row>

                <b-card :key="key">
                    <b-row>
                        <b-col cols="6">
                            <b-table-simple hover small responsive bordered>
                                <b-tbody>
                                    <b-tr>
                                        <b-td class="text-center" colspan="4">
                                            <h5>{{ item.name }}</h5>
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-th>Category</b-th>
                                        <b-td>{{ item.category && item.category.name }}</b-td>
                                        <b-th>SKU</b-th>
                                        <b-td>{{ item.sku }}</b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-th>Product ID</b-th>
                                        <b-td>{{ item.id }}</b-td>
                                        <b-th>Sales Price</b-th>
                                        <b-td>${{ numberWithCommas(item.price) || '0.00' }}</b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-th>Build With</b-th>
                                        <b-td></b-td>
                                        <b-th>WAC</b-th>
                                        <b-td>
                                            <span v-if="$can('view-all') || $can('view-product-cost')">${{ numberWithCommas(item.weighted_cost) || '0.00' }}</span>
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-th>Total Stock</b-th>
                                        <b-td>{{ item.qty_total }}</b-td>
                                        <b-th>Latest Cost</b-th>
                                        <b-td>
                                            <span
                                                v-if="item.last_cost && item.last_cost[0] && item.last_cost[0].price && ($can('view-all') || $can('view-product-cost'))">${{
                                                numberWithCommas(item.last_cost[0].price) || '0.00' }}</span>
                                        </b-td>
                                    </b-tr>
                                    <b-tr v-for="location in inventoryLocations" :key="'location-' + location.id">
                                        <b-th>{{ location.name }} QTY</b-th>
                                        <b-td>{{ getLocationQty(item, location) }}</b-td>
                                        <b-th>BIN ({{ location.name }})</b-th>
                                        <b-td>{{ getLocationBin(item, location) }}</b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-th>QTY Available</b-th>
                                        <b-td>{{ item.qty_available || 0}}</b-td>
                                        <b-th>QTY On Orders</b-th>
                                        <b-td>
                                            <b-link
                                                @click="openModal('modal-inventory-products-show-open-orders', item.sales_order_lines)">
                                                {{ item.qty_ordered || 0 }}</b-link>
                                        </b-td>

                                    </b-tr>
                                    <b-tr>
                                        <b-th>Open Orders</b-th>
                                        <b-td>
                                            <b-link
                                                @click="openModal('modal-inventory-products-show-open-orders', item.sales_order_lines)">
                                                <span v-if="item != ''">{{ calculateOpenOrders(item.sales_order_lines)
                                                || 0}}</span>
                                            </b-link>
                                        </b-td>
                                        <b-th>Total Inventory Value</b-th>
                                        <b-td>${{ numberWithCommas(item.total_value) || '0.00' }}</b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-th>Tags</b-th>
                                        <b-td colspan="3">{{ tags }}</b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-th>Attributes</b-th>
                                        <b-td colspan="3">{{ attributes }}</b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-th>Total QTY Sold</b-th>
                                        <b-td colspan="3"></b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-th>Net Revenue Generated</b-th>
                                        <b-td colspan="3"></b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-th colspan="4">Short Description</b-th>
                                    </b-tr>
                                    <b-tr>
                                        <b-td colspan="4" v-html="item.description" />
                                    </b-tr>
                                </b-tbody>
                            </b-table-simple>
                        </b-col>

                        <b-col cols="6">
                            <b-row v-if="item && item.item_image && item.item_image.length">
                                <b-col class="text-center">
                                    <b-img v-if="item"
                                        :src="getImageUrl(item.sku, 'MEDIUM', currentImage, currentExtension) + '?rnd=' + cacheKey">
                                    </b-img>
                                </b-col>

                                <b-col class="text-center thumbnails" cols="2">
                                    <b-img @click="currentImage = img.sequence; currentExtension = img.extension"
                                        v-for="(img, index) in item.item_image" :key="index + '?rnd=' + cacheKey"
                                        :src="getImageUrl(item.sku, 'SMALL', img.sequence, img.extension) + '?rnd=' + cacheKey"
                                        @error="$event.target.src = ''"></b-img><br />
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-card>

                <hr>

                <b-row>
                    <b-col>
                        <h5>Notes</h5>
                    </b-col>
                    <b-col cols="6" class="text-right note-button">
                        <b-button variant="outline-primary"
                            @click="openModal('modal-inventory-products-details-item-note')" size="sm"><i
                                class="far fa-comment-alt"></i> Add Item Note</b-button>
                    </b-col>
                </b-row>

                <b-card class="notes">
                    <b-table-simple hover small responsive bordered :key="tables.notes.key">
                        <b-tbody>
                            <b-tr v-for="(note, index) in tables.notes.items" :key="index">
                                <b-td class="text-center notes-date">{{ note.created_at | moment('YYYY-MM-DD HH:mm:ss')
                                }}</b-td>
                                <b-td class="text-center notes-note">{{ note.note }}</b-td>
                                <b-td class="text-center notes-user"><strong>{{ note.user.name }}</strong></b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-card>

                <hr>

                <b-card no-body>
                    <b-tabs card justified>
                        <b-tab title="Quick Report" active>
                            <b-card-text>
                                <b-container fluid>
                                    <b-row class="button-row-2">
                                        <b-col cols="3">
                                            <b-form-group>
                                                <b-input-group size="sm">
                                                    <b-form-input v-model="tables.ledger.filter" type="search"
                                                        id="filterInput" placeholder="Type to Search" debounce="500">
                                                    </b-form-input>
                                                    <b-input-group-append>
                                                        <b-button :disabled="!tables.ledger.filter"
                                                            @click="tables.ledger.filter = ''">Clear</b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="3">
                                            <treeselect name="typesSelect" class="typesSelect" clearable
                                                :searchable="false" open-on-click clear-on-select close-on-select
                                                disableBranchNodes placeholder="Filter by Type"
                                                :options="tables.ledger.types" @input="filterByTypes" />
                                        </b-col>
                                        <b-col cols="3">
                                            <treeselect name="typesSelect" class="typesSelect" clearable
                                                :searchable="false" open-on-click clear-on-select close-on-select
                                                disableBranchNodes placeholder="Filter by Location"
                                                :options="tables.ledger.locations" @input="filterByLocations" />
                                        </b-col>
                                    </b-row>
                                </b-container>

                                <b-card style="margin-bottom: 15px;">
                                    <b-table :key="tables.ledger.key" class="products-table" responsive bordered hover
                                        no-border-collapse sticky-header="600px" head-variant="light"
                                        :items="tables.ledger.items" :fields="tables.ledger.fields"
                                        :sort-by="tables.ledger.sortBy" :sort-desc="tables.ledger.sortDesc"
                                        :per-page="tables.ledger.perPage" :current-page="tables.ledger.currentPage"
                                        :filter="tables.ledger.filter" :filterIncludedFields="tables.ledger.filterOn"
                                        @filtered="onFiltered" :busy="tables.ledger.isBusy">

                                        <template v-slot:table-busy>
                                            <div class="text-center text-default my-2">
                                                <b-spinner class="align-middle"></b-spinner>
                                                <strong>Loading...</strong>
                                            </div>
                                        </template>

                                        <template v-slot:cell(reference_id)="row">
                                            <span v-if="row.item.type == 'Sales Order'">
                                                <b-link
                                                    :to="{name: 'SalesOrderDetail', params: { soNum: row.item.reference_id } }">
                                                    {{ row.item.reference_id }}</b-link>
                                            </span>
                                            <span v-else-if="row.item.type == 'Bill'">
                                                <b-link
                                                    :to="{name: 'BillsDetail', params: { billNum: row.item.reference_id } }">
                                                    {{ row.item.reference_id }}</b-link>
                                            </span>
                                            <span v-else-if="row.item.type == 'Build'">
                                                <b-link
                                                    @click="openModal('modal-inventory-products-edit-kit', row.item.reference_id)">
                                                    {{ row.item.reference_id }}</b-link>
                                            </span>
                                            <span v-else-if="row.item.type == 'Transfer'">
                                                <b-link
                                                    @click="openModal('modal-warehousing-stocktransfer-edit-transfer', row.item.reference_id)">
                                                    {{ row.item.reference_id }}</b-link>
                                            </span>
                                        </template>

                                        <template v-slot:cell(customer_vendor)="row">
                                            <span v-if="row.item.type == 'Sales Order'">
                                                <b-link
                                                    :to="{name: 'CustomerDetail', params: { id: row.item.customer_vendor_id } }">
                                                    {{ row.item.customer_vendor }}</b-link>
                                            </span>
                                            <span v-else-if="row.item.type == 'Bill'">
                                                <b-link
                                                    :to="{name: 'VendorDetail', params: { id: row.item.customer_vendor_id } }">
                                                    {{ row.item.customer_vendor }}</b-link>
                                            </span>
                                        </template>

                                        <template v-slot:cell(price)="row">
                                            <span>$ {{ numberWithCommas(row.item.price) || '0.00' }}</span>
                                        </template>

                                        <!-- <template v-slot:cell(notes)="row">
                                            <span v-if="row.item.type == 'Sales Order'">{{ row.item.so.notes }}</span>
                                        </template> -->
                                    </b-table>

                                    <b-row>
                                        <b-col cols="6">
                                            {{ pageTotals }}
                                        </b-col>

                                        <b-col cols="6" class="my-1">
                                            <b-pagination v-model="tables.ledger.currentPage"
                                                :total-rows="tables.ledger.totalRows" :per-page="tables.ledger.perPage"
                                                align="fill" size="sm" class="my-0"></b-pagination>
                                        </b-col>
                                    </b-row>
                                </b-card>
                            </b-card-text>
                        </b-tab>
                    </b-tabs>
                </b-card>

                <modal-edit-product v-if="modals['modal-inventory-products-edit-product'].active" :row="item.id"
                    :categories="modals['modal-inventory-products-edit-product'].categories"
                    :vendors="modals['modal-inventory-products-edit-product'].vendors"
                    :tags="modals['modal-inventory-products-edit-product'].tags"
                    :attributes="modals['modal-inventory-products-edit-product'].attributes"
                    :attributesFilters="modals['modal-inventory-products-edit-product'].attributesFilters"
                    :attributesOptions="modals['modal-inventory-products-edit-product'].attributesOptions"
                    @updateRow="updateRow" />

                <modal-create-item-note v-if="modals['modal-inventory-products-details-item-note'].active" :id="item.id"
                    @createNoteRow="createNoteRow" />

                <modal-adjust-quantity v-if="modals['modal-inventory-products-adjust-quantity'].active" :id="item.id"
                    @updateRow="updateRow" />

                <modal-edit-transfer v-if="modals['modal-warehousing-stocktransfer-edit-transfer'].active"
                    :referenceId="modals['modal-warehousing-stocktransfer-edit-transfer'].referenceId"
                    @updateRow="updateRow" />

                <modal-edit-sources v-if="modals['modal-inventory-products-edit-sources'].active" :id="item.id" />

                <modal-show-open-orders v-if="modals['modal-inventory-products-show-open-orders'].active"
                    :lines="modals['modal-inventory-products-show-open-orders'].lines" />

                <modal-build-kit v-if="modals['modal-inventory-products-build-kit'].active"
                    :components="item.components" :sku="item.sku" :id="item.id" @getRow="getRow" />

                <modal-edit-kit v-if="modals['modal-inventory-products-edit-kit'].active" :components="item.components"
                    :cost="item.cost" :sku="item.sku" :id="item.id"
                    :referenceId="modals['modal-inventory-products-edit-kit'].referenceId" @getRow="getRow" />
            </b-container>
        </b-row>
    </b-container>
</template>

<script>
	import Treeselect from '@riophae/vue-treeselect'
	import ModalEditProduct from './modals/Edit'
    import ModalCreateItemNote from './modals/CreateItemNote'
    import ModalAdjustQuantity from './modals/AdjustQuantity'
    import ModalEditTransfer from '../../warehousing/stocktransfer/modals/EditTransfer'
    import ModalEditSources from './modals/EditSources'
    import ModalShowOpenOrders from './modals/ShowOpenOrders'
    import ModalBuildKit from './modals/BuildKit'
    import ModalEditKit from './modals/EditKit'
    import { getLocationQty, getLocationBin } from '../../../../utils/inventoryLocations'
	export default {
		name: 'ProductDetail',

        metaInfo() {
            return {
                title: 'Item - ' + this.item.sku + ' - ' + this.item.name,
            }
        },

		props: [ 'sku' ],

		components: {
			Treeselect,
			'modal-edit-product': ModalEditProduct,
            'modal-create-item-note': ModalCreateItemNote,
            'modal-adjust-quantity': ModalAdjustQuantity,
            'modal-edit-transfer': ModalEditTransfer,
            'modal-edit-sources': ModalEditSources,
            'modal-show-open-orders': ModalShowOpenOrders,
            'modal-build-kit': ModalBuildKit,
            'modal-edit-kit': ModalEditKit
		},

		data() {
            return {
            	modals: {
                    'modal-inventory-products-edit-product': {
                        active: 0,
                        categories: [],
                        vendors: [],
                        tags: [],
                        attributes: [],
                        attributesFilters: [],
                        attributesOptions: []
                    },

                    'modal-inventory-products-details-item-note': {
                    	active: 0
                    },

                    'modal-inventory-products-adjust-quantity': {
                        active: 0
                    },

                    'modal-warehousing-stocktransfer-edit-transfer': {
                        active: 0,
                        referenceId: ''
                    },

                    'modal-inventory-products-edit-sources': {
                        active: 0
                    },

                    'modal-inventory-products-build-kit': {
                        active: 0
                    },

                    'modal-inventory-products-edit-kit': {
                        active: 0,
                        referenceId: ''
                    },

                    'modal-inventory-products-show-open-orders': {
                        active: 0,
                        lines: []
                    }
                },

                key: 0,
                cacheKey: 0,
                item: [],
                inventoryLocations: [],
                currentImage: null,
                currentExtension: null,
            	tags: '',
            	attributes: '',
            	feedFilter: null,
                exportingSales: false,

            	tables: {
                    ledger: {
                        isBusy: false,
                        totalRows: 1,
                        currentPage: 1,
                        perPage: 20,
                        pageOptions: [20, 50, 100, 500, 1000],
                        sortBy: 'date',
                        sortDesc: true,
                        // sortDirection: 'asc',
                        filter: null,
                        filterOn: [],
                        key: 1,
                        fields: [
                            {
                                key: 'date',
                                label: 'Date',
                                sortable: true,
                                thStyle: { 'white-space': 'nowrap' }
                            },
                            {
                                key: 'reference_id',
                                label: 'Reference # / Order #',
                                sortable: true,
                                thStyle: { 'white-space': 'nowrap' }
                            },
                            {
                                key: 'type',
                                label: 'Type',
                                sortable: true
                            },
                            {
                                key: 'customer_vendor',
                                label: 'Customer / Vendor',
                                sortable: true
                            },
                            {
                                key: 'notes',
                                label: 'Description'
                            },
                            {
                                key: 'price',
                                label: 'Price',
                                sortable: true,
                            },
                            {
                                key: 'qty',
                                label: 'QTY',
                                sortable: true,
                            },
                            {
                                key: 'location',
                                label: 'Location',
                                sortable: true,
                            },
                            // {
                            //     key: 'qty_previous',
                            //     label: 'QOH',
                            // }
                        ],

                        items: [],
                        itemsCopy: [],

                        types: [
                        	{
                        		id: 'Info',
                        		label: 'Info'
                        	},
                        	{
                        		id: 'Sales Order',
                        		label: 'Sales Order'
                            },
                            {
                                id: 'Credit Memo',
                                label: 'Credit Memo',
                            },
                        	{
                        		id: 'Bill',
                        		label: 'Bill'
                        	},
                        	{
                        		id: 'Transfer',
                        		label: 'Transfer'
                        	},
                            {
                        		id: 'Build',
                        		label: 'Build'
                        	},
                        ],

                        locations: []
                    },

                    notes: {
                    	items: [],
                    	key: 0
                    }
                }
            }
        },

        methods: {
            getLocationQty(item, location) {
                return getLocationQty(item, location)
            },

            getLocationBin(item, location) {
                return getLocationBin(item, location)
            },

            loadInventoryLocations() {
                axios.get('api/inventory/products/getproductsconfig')
                    .then((res) => {
                        this.inventoryLocations = (res.data.config && res.data.config.locations) ? res.data.config.locations : []
                    }, () => {
                        this.has_error = true
                    })
            },

            recalcCounts() {
                let url = 'api/inventory/products/recalculate/' + this.item.id
                axios.get(url, {})
                .then((res) => {
                    this.getRow()
                    this.showAlertBox('success', 'Recalculate Counts', 'Counts recalculated successfully!')
                }, () => {
                    this.has_error = true
                })
            },

            exportSales() {
                if (!this.item || !this.item.id) {
                    return
                }

                this.exportingSales = true
                let url = 'api/inventory/products/details/exportsales/' + this.item.id
                axios.get(url, { responseType: 'blob' })
                .then((res) => {
                    const downloadUrl = window.URL.createObjectURL(new Blob([res.data]))
                    const link = document.createElement('a')
                    link.href = downloadUrl
                    link.setAttribute('download', 'Product_Sales_' + this.item.sku + '_' + this.$moment().format('YYYY-MM-DD') + '.xlsx')
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                    this.showAlertBox('success', 'File Generated', 'Product sales export generated successfully!')
                }, () => {
                    this.has_error = true
                })
                .finally(() => {
                    this.exportingSales = false
                })
            },

        	createNoteRow(row) {
                this.tables.notes.items.unshift(row)
                this.tables.notes.key++
            },

        	updateRow() {
                this.getRow()
                this.key++
                this.cacheKey = this.$moment().unix()
            },

        	openModal(modalName, row) {
                switch (modalName) {
                    case 'modal-inventory-products-edit-kit':
                        this.modals[modalName].referenceId = row

                        break
                    case 'modal-warehousing-stocktransfer-edit-transfer':
                        this.modals[modalName].referenceId = row

                        break
                    case 'modal-inventory-products-edit-product':
                        // this.modals[modalName].active = 1

                        break
                    case 'modal-inventory-products-details-item-note':
                        // this.modals[modalName].active = 1

                        break
                    case 'modal-inventory-products-show-open-orders':
                        this.modals[modalName].active = 1

                        let lines = []
                        row.forEach((row, idx, array) => {
                            if (row.sale_order.status != 'Confirmed' || row.sale_order.status != 'Pending') {
                                lines.push(row)
                            }
                        })
                        this.modals[modalName].lines = lines

                        break
                }

                this.modals[modalName].active = 1

                this.$nextTick(() => {
                    this.$bvModal.show(modalName)
                })
            },

        	getRow() {
                let url = 'api/inventory/products/getproduct/' + this.sku
                axios.get(url, {})
                .then((res) => {
                    this.item = res.data.items
                    this.currentImage = res.data.items.item_image[0] != undefined ? res.data.items.item_image[0].sequence : null
                    this.currentExtension = res.data.items.item_image[0] != undefined ? res.data.items.item_image[0].extension : null

                    // this.tables.ledger.items = res.data.items.transaction_ledger
                    // this.tables.ledger.itemsCopy = res.data.items.transaction_ledger
                    // this.tables.ledger.totalRows = this.tables.ledger.items.length

                    this.tables.notes.items = res.data.items.item_note

                    if (res.data.items.item_attribute) {
                        this.attributes = ''
                    	res.data.items.item_attribute.forEach((attribute, idx, array) => {
                    		if (idx === array.length - 1) {
                    			this.attributes += this.findAttributeName(attribute.attributes_id) + ': ' + attribute.item_attribute_option.attribute_option.value
                    		} else {
                    			this.attributes += this.findAttributeName(attribute.attributes_id) + ': ' + attribute.item_attribute_option.attribute_option.value + ' | '
                    		}
                    	})
                    }

                    if (res.data.items.tags) {
                        this.tags = ''
                        res.data.items.tags.forEach((tag, idx, array) => {
                        	if (idx === array.length - 1) {
                            	this.tags += tag.tag.name
                            } else {
                            	this.tags += tag.tag.name + ' | '
                            }
                        })
                    }

                    this.getTransactions()
                }, () => {
                    this.has_error = true
                })
            },

            findAttributeName(id) {
                let index = this.findIndex(this.modals['modal-inventory-products-edit-product'].attributes, 'id', id)
                return this.modals['modal-inventory-products-edit-product'].attributes[index].name
            },

            onFiltered(filteredItems) {
                this.tables.ledger.totalRows = filteredItems.length
                this.tables.ledger.currentPage = 1
            },

            filterByTypes(type) {
                this.tables.ledger.items = this.tables.ledger.itemsCopy
                if (type == undefined) {
					this.tables.ledger.filterOn = []
					// this.tables.ledger.items = this.tables.ledger.itemsCopy
                } else {
                	this.tables.ledger.items = this.tables.ledger.items.filter(function(itm) {
                		return itm.type == type
                	})
                }

                this.onFiltered(this.tables.ledger.items)
            },

            filterByLocations(location) {
                this.tables.ledger.items = this.tables.ledger.itemsCopy
                if (location == undefined) {
					this.tables.ledger.filterOn = []
					// this.tables.ledger.items = this.tables.ledger.itemsCopy
                } else {
                	this.tables.ledger.items = this.tables.ledger.items.filter(function(itm) {
                		return itm.location == location
                	})
                }

                this.onFiltered(this.tables.ledger.items)
            },

            getCategories() {
                let url = 'api/inventory/products/getcategoriesfilter'
                axios.get(url, {})
                .then((res) => {
                    this.modals['modal-inventory-products-edit-product'].categories = res.data.categories
                }, () => {
                    this.has_error = true
                })
            },

            getVendors() {
                let url = 'api/inventory/products/getvendorsfilter'
                axios.get(url, {})
                .then((res) => {
                    this.modals['modal-inventory-products-edit-product'].vendors = res.data.vendors
                }, () => {
                    this.has_error = true
                })
            },

            toggleBusy() {
                this.tables.ledger.isBusy = !this.tables.ledger.isBusy ? true : false
            },

            getTransactions(silent) {
                if (!silent) {
                    this.toggleBusy()
                }

                let url = 'api/inventory/products/details/gettransactions/' + this.item.id
                axios.get(url, {})
                .then((res) => {
                    this.tables.ledger.items = res.data.transactions
                    this.tables.ledger.itemsCopy = res.data.transactions
                    this.tables.ledger.totalRows = this.tables.ledger.items.length

                    if (!silent) {
                        this.toggleBusy()
                    }
                }, () => {
                    this.has_error = true
                })
            },

            getTags() {
                let url = 'api/inventory/products/gettagsfilter'
                axios.get(url, {})
                .then((res) => {
                    this.modals['modal-inventory-products-edit-product'].tags = res.data.tags
                    this.getRow()
                }, () => {
                    this.has_error = true
                })
            },

            getAttributes() {
                let url = 'api/inventory/products/getattributesfilter'
                axios.get(url, {})
                .then((res) => {
                    this.modals['modal-inventory-products-edit-product'].attributes = res.data.attributes
                    this.modals['modal-inventory-products-edit-product'].attributesFilters = res.data.attributesFilters
                    this.modals['modal-inventory-products-edit-product'].attributesOptions = res.data.attributesOptions
                }, () => {
                    this.has_error = true
                })
            },

            // calculateOpenOrders(lines) {
            //     let count = 0

            //     lines.forEach((row, idx, array) => {
            //         if (row.sale_order.status == 'Confirmed' || row.sale_order.status == 'Dispatched') {
            //             count++
            //         }
            //     })

            //     return count
            // },
        },

        computed: {
            pageTotals() {
                let totalRows = this.tables.ledger.totalRows
                let currentPage = this.tables.ledger.currentPage
                let perPage = this.tables.ledger.perPage

                let from
                let to

                if (perPage > totalRows) {
                    from = 1
                    to = totalRows
                } else {
                    to = perPage * currentPage
                    from = to - perPage + 1
                }

                return 'Showing ' + from + ' to ' + to + ' of ' + this.tables.ledger.totalRows + ' rows'
            }
        },

        mounted() {
            this.cacheKey = this.$moment().unix()
            this.loadInventoryLocations()
        	this.getAttributes()
        	this.getCategories()
        	this.getVendors()
        	this.getTags()
        	// this.getRow()
            // this.tables.ledger.locations = Object.keys(this.getLocations)

            Object.keys(this.getLocations).forEach((row, idx, array) => {
                this.tables.ledger.locations.push({id: row, label: row})
            })

        	this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
                switch (modalId) {
                    case 'modal-inventory-products-edit-product':
                        this.modals[modalId].active = 0

                        break

                    case 'modal-inventory-products-details-item-note':
                    	this.modals[modalId].active = 0

                        break

                    case 'modal-inventory-products-adjust-quantity':
                        this.modals[modalId].active = 0

                        break

                    case 'modal-warehousing-stocktransfer-edit-transfer':
                        this.modals[modalId].active = 0
                        this.modals[modalId].referenceId = ''

                        break

                    case 'modal-inventory-products-edit-sources':
                        this.modals[modalId].active = 0

                        break

                    case 'modal-inventory-products-build-kit':
                        this.modals[modalId].active = 0

                        break

                    case 'modal-inventory-products-edit-kit':
                        this.modals[modalId].active = 0
                        this.modals[modalId].referenceId = ''

                        break

                    case 'modal-inventory-products-show-open-orders':
                        this.modals[modalId].active = 0

                        break

                    default:

                        break
                }
            })
        }
	}
</script>

<style lang="scss">
	#inventory-products-details {
		.vue-treeselect__control {
	        font-size: 0.875rem !important;
	        height: 31px;

	        .vue-treeselect__placeholder {
	        	line-height: 29px;
	        }
	    }

        .thumbnails img {
            cursor: pointer;
            width: 50px;
            height: 50px;
            border: 1px #ccc solid;
            padding: 5px;
            margin: 5px;
        }

		.button-row {
			margin-bottom: 1rem;
		}

		.button-row-2 {
			margin-top: 1rem;
			margin-bottom: 0;
		}

		.notes {
			.note-button {
				padding-bottom: 5px;
			}

			.notes-date {
				width: 157px;
			}

			.notes-note {
				white-space: pre-wrap;       /* css-3 */
				white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
				white-space: -pre-wrap;      /* Opera 4-6 */
				white-space: -o-pre-wrap;    /* Opera 7 */
				word-wrap: break-word;
			}

			.notes-user {
				width: 115px;
			}
		}
	}
</style>
